import { useLoadScript } from '@btime/react-hooks'

export const useGooglePlacesScript = () => {
  const key = process.env.REACT_APP_GOOGLE_API_KEY
  const url = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`
  return useLoadScript(url)
}
